import React from 'react';

import ColorSelector from 'components/Colors/ColorSelector';
import ColorSwitch from 'components/Colors/ColorSwitch';
import Rubber from 'components/Builder/Rubber';
import Select from 'components/Builder/Select';
import MoveGroup from 'components/Builder/MoveGroup';
import AddGroup from 'components/Builder/AddGroup';

import useSetting from 'hooks/useSetting';
import useGroup from 'hooks/useGroup';


function Tools(props) {
	let {
		zoom = {
			currentZoom: 1
		},
		wrapper,
		setActive,
		active,
		disabled
	} = props;

	const {
		MODE_KEY,
		mode,
	} = useSetting();


	const {
		group
	} = useGroup();

	let hasDomino = true;
	if (group && typeof group.count !== 'undefined') {
		if (parseInt(group.count, 10) === 0) {
			hasDomino = false;
		}
	}
	return (
		<div className="settings-buttons-container" id="Tools">

			<AddGroup disabled={disabled} />
			<Select
				active={active === 3 || mode === MODE_KEY.select}
				setActive={setActive}
				disabled={disabled}
				wrapper={wrapper}
				currentZoom={zoom.currentZoom}
			/>
			<ColorSelector active={active === 0} setActive={setActive} disabled={disabled} />
			<ColorSwitch currentZoom={zoom.currentZoom} disabled={hasDomino === false || disabled} />
			<Rubber active={active === 1} setActive={setActive} disabled={disabled} />
			<MoveGroup
				disabled={hasDomino === false}
				active={active === 5}
				setActive={setActive}
				setFetchingGroup={props.setFetchingGroup}
			/>
		</div>
	);
}

export default Tools;
